<template>
  <ChecklistList />
</template>

<script>
import ChecklistList from '../components/ChecklistList.vue';

export default {
  components: { 
    ChecklistList
  }
}
</script>